// UserProfile.js
import React, { useRef } from 'react';
import PageHeading from '../../components/pageHeading/PageHeading';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import UserProfileSidebar from './userProfileSidebar/UserProfileSidebar';
import AccountSetting from './accountSetting/AccountSetting';
import './userProfile.scss';

const UserProfile = () => {
  // Ref for the container element to scroll
  const containerRef = useRef(null);

  // Function to scroll to a specific section based on the ID
  const scrollToSection = (sectionId) => {
    // console.log('scrollToSection--',sectionId);
    const sectionElement = document.getElementById(sectionId);
    if (sectionElement) {
      // sectionElement.scrollIntoView({ behavior: 'smooth' });
      const currentScrollY = window.scrollY;
    const targetScrollY = sectionElement.offsetTop - 150;
    window.scrollTo({
        top: targetScrollY,
        behavior: 'smooth',
    });
    }
  };

  return (
    <>
      <Header />
      <PageHeading title="User Profile" />
      <div className='main-container'>
        <div className='container-wrap'>
          <div className='user-profile-container' ref={containerRef}>
            {/* Pass scrollToSection as a prop to UserProfileSidebar */}
            <UserProfileSidebar scrollToSection={scrollToSection} />
            {/* Pass the containerRef as a prop to AccountSetting */}
            <AccountSetting  />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserProfile;
